import Enum from './enum'

class MappedEvaluationItemType extends Enum {
    static KNOWLEDGE = 1; // 知識
    static SKILL = 2; // 技能
    static IDEA = 3; // 発想構想
    static APPRECIAtITON = 4; // 鑑賞
    static ATTITUDE = 5; // 主体的に学習に取り組む態度

    static values() {
        return {
            [this.KNOWLEDGE]: '知識',
            [this.SKILL]: '技能',
            [this.IDEA]: '発想構想',
            [this.APPRECIAtITON]: '鑑賞',
            [this.ATTITUDE]: '主体的に学習に取り組む態度',
        }
    }
}

export default MappedEvaluationItemType;
